module.exports = __webpack_public_path__ + "static/media/funchal-16.6689e974.jpg";